import {Injectable} from '@angular/core';
import {TextBase} from '@im-ng/text';

/**
 * 순서 문자열
 *
 * @inheritDoc
 * @see TextBase
 */
@Injectable({
  providedIn: 'root'
})
export class SelectorText extends TextBase {
  override readonly en = {
    previous: 'Previous',
    next: 'Next'
  };

  override readonly kr = {
    previous: '다음',
    next: '이전'
  };
}
